import { Component } from 'react'
import Head from 'next/head'
import PageLink from 'Components/PageLink'

import AppBar from 'Components/AppBar'
import Breadcrumb from 'Components/Breadcrumb'
import Footer from 'Components/Footer'
import StoreAddress from 'Components/Stores/StoreAddress'
import { SVGArrowBack, SVGPlusOrange } from 'Components/SVGCollection'
import { ViewType as AppBarViewType } from 'Components/AppBar/AppBar'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import prnt from 'Components/Stores/StoresPage.scss'
import { AppContext } from 'Utils/withReduxStore'

import { stores } from 'Utils/data/stores'
import { redirect } from 'Utils/helpers/routerHelper'
import StoreGallery from 'Components/StoreGallery/Gallery'
import cl from 'Scss/pages/store.scss'
import { formatBreadcrumbForGtm } from 'Components/Breadcrumb/Breadcrumb';

type PropType = { store: Webshop.IStoreData }

class StorePage extends Component<PropType> {
  static async getInitialProps ({ query: { id }, res }: AppContext): Promise<Partial<PropType>> {
    const store = stores.find(store => store.id === id)
    if (!store) {
      redirect('/404', res)
      return {}
    }

    return { store }
  }

  render() {
    const { store } = this.props

    const breadcrumbData = [
      {
        href: '/',
        title: 'Főoldal',
        gtmName: 'Home'
      },
      {
        href: '/uzletek',
        title: 'Üzleteink',
        gtmName: 'Stores'
      },
      {
        href: `/uzletek/${store.id}`,
        title: store.name,
        gtmName: store.name
      }
    ]

    return (
      <div>
        <Head>
          <title>Üzleteink - {store.name}</title>
        </Head>

        <AppBar
          viewType={AppBarViewType.SubPage}
          pageTitle={store.name}
          pageType="Home"
          breadcrumb={formatBreadcrumbForGtm(breadcrumbData)}
        />

        <div className={cn(cg.gridContainer, prnt.storesContainer)}>
          <div className={cn(cg.showForMedium, prnt.breadcrumbContainer)}>
            <Breadcrumb data={breadcrumbData} />
          </div>

          <div className={cn(cg.gridX, cg.alignMiddle, cg.showForMedium,)}>
            <div className={cn(cg.cell, cg.shrink)}>
              <PageLink toPage="/uzletek" className={cl.linkBack}>
                <span className={cg.showForSr}>
                  Vissza
                </span>
                <span aria-hidden="true">
                  <SVGArrowBack width="32" height="32" />
                </span>
              </PageLink>
            </div>
            <div className={cn(cg.cell, cg.auto)}>
              <h1 className={prnt.h1}>{store.name}</h1>
            </div>
          </div>

          <StoreAddress store={store} />

          <div className={cn(cl.homeHeading, cg.gridX, cg.showForMedium)}>
            <h3 className={cn(cg.cell, cg.auto)}>Képek az üzletről</h3>
            <div className={cn(cg.cell, cg.shrink)}>
              <PageLink toPage="/uzletek">
                <span className={cn(cl.more)}>
                  <span>További üzleteink</span>
                  <SVGPlusOrange width={24} height={24} />
                </span>
              </PageLink>
            </div>
          </div>

          <div className={cn(cg.gridX, cg.alignMiddle, cg.showForMedium)}>
            <div className={cn(cg.cell, cg.medium12)}>
              <StoreGallery store={store} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default StorePage
